"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseUrl = void 0;
function baseUrl(isNewApi, maybeBaseUrl) {
    var maybeTestkitUrl = process.env.NODE_ENV === 'test' && isNewApi && 'http://localhost:5700';
    return maybeBaseUrl || maybeTestkitUrl || '';
}
exports.baseUrl = baseUrl;
//# sourceMappingURL=base-url.js.map